import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { Button, Icon, LoadingSpinner } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { cx } from '@/utils/cx'
import { navigateToComplete } from '@methods/dataCollection'
import type { CompleteContent } from '@/types/dataCollection'
import { resolveLabel } from './helpers'

export const SuccessScreen = observer(({ content }: { content: CompleteContent }) => {
  const store = useContext(StoreContext)
  const { language } = store.TranslationsState
  const { dataCollectionPage: trans } = store.TranslationsState.translations
  const [navigating, setNavigating] = useState(false)

  const complete = () => {
    setNavigating(true)
    navigateToComplete()
  }

  return (
    <div className="page-container mobile-m-0">
      <div className="layout__content-container-with-scroll data-collection__success">
        <div className="data-collection__success-icon">
          <Icon
            type="check-circle"
            size="56px"
            color="var(--data-collection-success-color, #76be74)"
          />
        </div>
        <h1 className="header__container onboarding-header data-collection__success-title">
          {resolveLabel(content.title, language)}
        </h1>
        {content.description && (
          <p className="generic__paragraph generic__paragraph-centered">
            {resolveLabel(content.description, language)}
          </p>
        )}
      </div>

      <div className="layout__content-container-bottom-fixed">
        <Button onClick={complete} disabled={navigating} dataTestid="data-collection-complete">
          {navigating && <LoadingSpinner inButton />}
          <span
            className={cx('generic__button-text', navigating && 'generic__button-text--loading')}
          >
            {resolveLabel(content.buttonLabel, language) || trans.next}
          </span>
        </Button>
      </div>
      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </div>
  )
})
